import styles from './Label.module.css.js';

const LABEL_SIZE_MAP = {
  default: styles.defaultLabel ,
  large: styles.largeLabel 
};

export { LABEL_SIZE_MAP };
